import { render, staticRenderFns } from "./PodiumView.vue?vue&type=template&id=cafdcb56&scoped=true&"
import script from "./PodiumView.vue?vue&type=script&lang=js&"
export * from "./PodiumView.vue?vue&type=script&lang=js&"
import style0 from "./PodiumView.vue?vue&type=style&index=0&id=cafdcb56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafdcb56",
  null
  
)

/* custom blocks */
import block0 from "./PodiumView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports